window.app = window.app || {};

$(function() {

console.log(app.config);

    app.init();

});

app.init = function() {
    // Ajax calls should always have the CSRF token attached to them, otherwise they won't work
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('#header-carousel').carousel({
		interval: $('#header-carousel').data('interval'), pause: 'false'
    });
	// }).on('slide.bs.carousel', function(e) {
// // console.log('slide');
        // var $item = $(e.relatedTarget);
        // $item.find('h1, h2').removeClass('fadeIn').addClass('fadeIn');
    // });
// .on('slid.bs.carousel', function(e){
//         var $item = $(e.relatedTarget);
//         setTimeout(function(){
//             $item.find('h1').removeClass('fadeOut').addClass('fadeIn');
//             setTimeout(function(){
//                 $item.find('h2').removeClass('fadeOut').addClass('fadeIn');
//             },1000);
//         },1000);
//     });

    // $('#header-carousel').find('h1, h2').addClass('fadeIn');

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        $("#header-carousel .item.active .carousel-image").css({
            'background-size': (100 + (scroll/25))+'%'
        });
        var ex = (150 - (scroll/75));
        if (ex < 100) { ex = 100; }
        $('section.expo').css({
            'background-size': ex+'%'
        });
    });


    app.initForms();
    app.initFormCollapse();
};
app.initForms = function() {
    var $form_ajax = $('.form-ajax');
    $form_ajax.each(function(i, form){
        var $form = $(form);
        $form.on('submit', function(e){
            e.preventDefault();
            var method = $form.attr('method');
            switch(method) {
                case 'post':
                case 'POST':
                    app.submitFormAjaxPost($form);
                break;
                case 'get':
                case 'GET':
                    app.submitFormAjaxGet($form);
                break;
                default:
                    app.submitFormAjaxGet($form);
                break;
            }
        });
    });
    $('select.placeholder').on('change', function(){
        $(this).removeClass('placeholder');
    });
};
app.submitFormAjaxPost = function($form) {
    if ($form[0].hasAttribute("data-parsley-validate")) {
        var p = $form.parsley();
        if (!p.validationResult) {
            bootbox.alert({
                message: '<h3><i class="fa fa-warning fa-btn"></i>Foutieve invoer formulier</h3>',
                buttons: {
                    ok: {label: '<i class="fa fa-check fa-btn"></i>Ok', className: 'btn-primary'}
                }
            })
            return;
        }
    }
    var url = $form.attr('action');
    var data = $form.serialize();
    var $form_component = $form.parents('.form-component').first();
    var $form_init = $form_component.find('.form-init').first();
    var $form_sending = $form_component.find('.form-sending').first();
    var $form_success = $form_component.find('.form-success').first();
    var $form_error = $form_component.find('.form-error').first();
    if ($form_sending) {
        $form_sending.show();
        $form_init.hide();
        $('html, body').animate({
            scrollTop: ($form_sending.offset().top)
        },750);
    }
    $.ajax({
        url: url, data: data, dataType: 'json', method: 'POST',
        success: function(res) {
// console.log(res);
            if (res.success) {
                $form_init.hide();
                if (res.obp_redirect_url && res.obp_redirect_url.length > 0 && res.obp_transaction) {
                    window.location.href = res.obp_redirect_url;
                } else {
                    if ($form_sending) {
                        $form_sending.hide();
                    }
                    $form_success.show();
                    $('html, body').animate({
                        scrollTop: ($form_success.offset().top)
                    },750);
                }
            } else {
                if (res.errors) {
                    var str = '';
                    $.each(res.errors, function(i, error){
                        str += '<strong>'+i+':</strong> '+error.join(', ');
                        str += '<br />';
                    });
                    bootbox.alert({
                        message: '<h3><i class="fa fa-warning fa-btn"></i>Fout</h3><p>'+str+'</p>',
                        buttons: {
                            ok: {label: '<i class="fa fa-check fa-btn"></i>Ok', className: 'btn-primary'}
                        }
                    });
                } else {
                    $form_init.hide();
                    if ($form_sending) {
                        $form_sending.hide();
                    }
                    $form_error.show();
                    $('html, body').animate({
                        scrollTop: ($form_error.offset().top)
                    },750);
                }
            }
        }
    });
};
app.submitFormAjaxGet = function($form) {

};
app.initFormCollapse = function() {

    var $form_collapses = $('.form-collapse');
    $form_collapses.on('show.bs.collapse', function() {
        var $el = $(this);
        $('a.btn.btn-form-collapse[href="#'+$el.attr('id')+'"]').hide();
        if ($el.data('hide')) {
            $($el.data('hide')).hide();
        }
        if ($el.data('show')) {
            $($el.data('show')).show();
        }
        if ($el.data('collapse-show')) {
            $($el.data('collapse-show')).collapse('show');
        }
    });
    $form_collapses.on('hide.bs.collapse', function() {
        var $el = $(this);
        $('a.btn.btn-form-collapse[href="#'+$el.attr('id')+'"]').show();
        if ($el.data('hide')) {
            $($el.data('hide')).show();
        }
    });

    $('#collapse_ideal').on('hide.bs.collapse', function(e){
        e.stopPropagation();
    });

};
